import { render } from "./App.vue?vue&type=template&id=10acd3c4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=10acd3c4&lang=scss"

import exportComponent from "/builds/shapkin/crm-mentoring.exportedu.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__